import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('settings-generals', storeModule.createStoreModule('settings-generals'))
